import Ajax from '../../../../util/ajax';
export function zigbeeMoveToLevel(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/8/command/move-to-level';
        const value = {
            'level': payload.level,
            'transition time': payload.transitionTime,
            'execute if off': payload.executeIfOff
        };
        ajax.post(url, value);
    };
}
